import apiClient from 'helpers/api-client';
import { request } from 'javascripts/services/v3ApiClient';
import eventEmitter from 'helpers/event-emitter';
import { EVENT_ADD_WAITING_ASSET } from 'constants/events';
import Steven from 'helpers/steven';

const createImageForProject = async (
  userId,
  imageURI,
  projectId,
  params = {},
) => {
  const path = `locations/${projectId}/images/async`;
  const photoData = {
    uri: imageURI,
    user_id: userId,
    degrade: true,
    date_uploaded: null,
    origin: 'external',
    ...params,
  };

  const apiData = await apiClient.post(path, { image: photoData });

  eventEmitter.trigger(EVENT_ADD_WAITING_ASSET, {
    asset_v1_id: apiData.id,
    user_id: photoData.user_id,
    location_id: projectId,
  });

  const stevenData = {
    captured_asset_id: `${apiData.id}`,
    captured_asset_type: 'photo',
  };

  Steven.uploadAction(stevenData);

  return apiData;
};

const createPhotoForProject = async (
  projectId,
  { uploadRequest, degrade = true, origin = 'external' },
) => {
  const response = await request({
    url: `projects/${projectId}/photos`,
    method: 'POST',
    data: {
      photo: {
        uploadRequest,
        degrade,
        origin,
      },
    },
  });

  const stevenData = {
    captured_asset_id: `${response.data.id}`,
    captured_asset_type: 'photo',
  };

  Steven.uploadAction(stevenData);

  return response;
};

export { createImageForProject, createPhotoForProject };
